<!-- BaseContainer.vue -->
<template>
  <div class="container custom">
    <slot />
  </div>
</template>

<style>
/* 
Ideal content width: 700px – 1000px

*/
.custom {
   max-width: 1400px;
  /*background: lightgoldenrodyellow; 
  border: 2px solid black;*/
}
</style>

